import { Link } from '@remix-run/react';
import { useStyles } from '@archipro-design/aria';
import * as S from './FeaturedProjects.mobile.style';
import ProjectTile from '~/modules/tile/component/project-tile/ProjectTile';
import React from 'react';
import type ProjectTileItem from '@modules/tile/type/project-tile-item';

import FeaturedItemsMobile from '~/modules/detail/components/featured-items/FeaturedItems.mobile';
import SaveToDesignBoard from '~/modules/design-board/component/SaveToDesignBoard';
import { useSaveToDesignBoard } from '~/modules/design-board/hook';

interface FeaturedProjectsData {
    Professional: {
        ID: number;
        Title: string;
        Link: string;
    };
    FeaturedProjects: {
        pageInfo: {
            totalCount: number;
        };
        edges: {
            node: ProjectTileItem;
        }[];
    };
}

interface FeaturedProjectsProps {
    data: FeaturedProjectsData;
}

const TILE_LIMIT = 4;

const FeaturedProjectsMobile = ({
    data: { Professional, FeaturedProjects },
}: FeaturedProjectsProps) => {
    const { css } = useStyles();
    const { favouriteItem } = useSaveToDesignBoard('ProjectPin');

    const { edges, pageInfo } = FeaturedProjects;
    if (!edges?.length) return null;

    const totalCount = pageInfo.totalCount;

    const displayLoadMore = totalCount > TILE_LIMIT;

    const viewMoreLink = `${Professional.Link}/case-studies`;

    return (
        <div className={css(S.FeaturedProjectsWrapper)}>
            <FeaturedItemsMobile
                gridType="single"
                title={
                    <>
                        More projects from
                        <br />
                        {Professional.Title}
                    </>
                }
                displayButton={displayLoadMore}
                button={{
                    as: Link,
                    to: viewMoreLink,
                    children: 'VIEW MORE',
                }}
            >
                {FeaturedProjects.edges.map((project) => {
                    return (
                        <div key={`featured-project-tile-${project.node.ID}`}>
                            <ProjectTile
                                data={project.node}
                                size="dynamic"
                                variables={{
                                    dynamicSizingWidth: 386,
                                    dynamicSizingGapWidth: 0,
                                    tilePadding: 0,
                                }}
                                variant="02"
                                favouriteItem={favouriteItem}
                            />
                        </div>
                    );
                })}
            </FeaturedItemsMobile>
            {favouriteItem.target && (
                <SaveToDesignBoard {...favouriteItem} autoReposition={false} />
            )}
        </div>
    );
};

export default FeaturedProjectsMobile;
